import { Component, EventEmitter, Input, Output } from '@angular/core';
import { McToastService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { UploadPhoto } from '../../store/images.actions';
import { Select, Store } from '@ngxs/store';
import { IMAGE_MANAGER_DIALOG_DATA } from '../../img-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { CarouselModalComponent } from '../carousel-modal/carousel-modal.component';
import { ImageItem, MODULES_OPTIONS } from '@app/_models/images-manager/images-management.model';
import { AppState } from '@app/core/store/app.state';
import { Observable } from 'rxjs';

@Component({
    selector: 'file-upload',
    templateUrl: 'file-upload.component.html',
    styleUrls: ['file-upload.component.scss'],
})
export class ImgFileUploadComponent {
    @Output() filesDropped = new EventEmitter<File[]>();

    files: { file: File; url: string }[] = [];
    selectedFiles: Set<{ file: File; url: string }> = new Set(); // Cambiado a Set<{ file: File, url: string }>
    loading: boolean = false;
    isFileUploadWindowOpen: boolean = false;
    htmlContent: string;

    @Input() data: IMAGE_MANAGER_DIALOG_DATA;

    @Output() closeDialog: EventEmitter<boolean> = new EventEmitter();

    @Select(AppState.isMobile)
    isMobile$: Observable<boolean>;

    // Lista de tipos de archivos permitidos
    private allowedTypes = ['image/png', 'image/bmp', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'];

    constructor(
        private toast: McToastService,
        private translate: TranslateService,
        private store: Store,
        private dialog: MatDialog
    ) {
        this.htmlContent = this.translate.instant(
            'app.global.modals.image_manager.upload_image_modal.computer.drag_drop'
        );
    }

    onFileDropped(files: File[]) {
        this.prepareFilesList(files);
    }

    prepareFilesList(files: Array<File>) {
        const selectedFiles = this.selectedFiles.size + files.length;
        if (selectedFiles > 15) {
            this.toast.danger(this.translate.instant('app.producto.toast.error_max_imagen', { limit: 15 }));
        }
        for (const item of files) {
            console.log('item >>> ', item);
            if (this.allowedTypes.includes(item.type)) {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    const url = e.target.result;
                    const fileData = { file: item, url };
                    this.files.push(fileData);
                    if (this.selectedFiles.size < 15) {
                        this.selectedFiles.add(fileData);
                    }
                    this.filesDropped.emit(this.files.map((f) => f.file));
                };
                reader.readAsDataURL(item);
            } else {
                this.toast.danger(
                    this.translate.instant(
                        'app.global.modals.image_manager.upload_image_modal.computer.invalid_image',
                        { img: item.name }
                    )
                );
            }
        }
    }

    fileBrowseHandler(event: any) {
        const files = event.target.files;
        this.prepareFilesList(files);
        this.isFileUploadWindowOpen = false;
    }

    deleteFile(index: number) {
        const removedFile = this.files.splice(index, 1)[0];
        this.selectedFiles.delete(removedFile); // Eliminar del Set si se borra
    }

    openFileUploadWindow(element: HTMLInputElement): void {
        if (!this.isFileUploadWindowOpen) {
            this.isFileUploadWindowOpen = true;
            element.click();

            element.addEventListener('cancel', (evt) => {
                this.isFileUploadWindowOpen = false;
            });
        }
    }

    toggleFileSelection(fileData: { file: File; url: string }): void {
        if (this.selectedFiles.has(fileData)) {
            this.selectedFiles.delete(fileData);
        } else {
            if (this.selectedFiles.size === 15) {
                this.toast.danger(this.translate.instant('app.producto.toast.error_max_imagen', { limit: 15 }));
                return;
            }
            this.selectedFiles.add(fileData);
        }
    }

    reset(): void {
        if (this.files?.length) {
            this.files = [];
            this.selectedFiles.clear();
        } else {
            this.closeDialog.emit(true);
        }
    }

    upload(): void {
        this.loading = true;
        const formData: FormData = new FormData();

        const selectedFiles = Array.from(this.selectedFiles);

        selectedFiles.forEach((fileData, index) => {
            formData.append(`data[${index}][file]`, fileData.file, fileData.file.name);
            formData.append(`data[${index}][relation_id]`, this.data.relation_id.toString());
            formData.append(`data[${index}][module]`, this.data.module);
            formData.append(`data[${index}][type]`, 'image');
        });

        this.store.dispatch(new UploadPhoto(formData)).subscribe({
            complete: () => (this.loading = false),
            error: () => (this.loading = false),
        });
    }

    openCarouselModal(index: number): void {
        const images: ImageItem[] = [];
        this.files.forEach((data: { file: File; url: string }, index) => {
            const item: ImageItem = {
                id: index,
                filetype: 'image',
                filepath: data.file.webkitRelativePath,
                filename: data.file.name,
                module: MODULES_OPTIONS.ALL,
                relation_id: this.data.relation_id.toString(),
                url: data.url,
                size: data.file.size,
                use_module: [],
            };
            images.push(item);
        });
        this.dialog.open(CarouselModalComponent, {
            data: { images, index },
            width: '80%',
            // height: '80%',
            panelClass: 'full-image-modal',
        });
    }
}
